import React, { useEffect, useState } from 'react'

import AnimateHeight, { AnimateHeightProps } from 'react-animate-height'
import { scrollIntoElement } from 'shared/utils'

import classes from './AnimatedForm.module.scss'

export type Props = {
  id: string
  scrollCenter: boolean
  open?: boolean
  onCloseClick?: () => void
  scrollToElement?: boolean
  duration?: number
  animationProp?: 'height' | 'opacity'
}

export const AnimatedForm = ({
  animationProp = 'height',
  scrollCenter,
  id,
  open,
  duration = 500,
  scrollToElement = true,
  children,
}: Props & React.HTMLAttributes<HTMLDivElement>): JSX.Element => {
  const [prevScrollPos, setPrevScrollPos] = useState(0)

  useEffect(() => {
    if (scrollCenter) {
      scrollIntoElement(id, undefined, true)
    }
  }, [scrollCenter, id])

  const handleAnimationEnd = () => {
    if (open) {
      setPrevScrollPos(window.scrollY)
      _scrollIntoElement()
    } else if (!open && prevScrollPos) {
      // возвращаем на ту позицию, где была страница до открытия формы
      window.scrollTo({
        top: prevScrollPos,
        behavior: 'smooth',
      })
    }
  }

  const _scrollIntoElement = () => {
    if (!scrollToElement) {
      return
    }

    const el = document.getElementById(id) as HTMLElement

    window.scrollTo({
      top: el?.getBoundingClientRect()?.top + window.scrollY - 72, // 72- высота шапки
      behavior: 'smooth',
    })
  }

  const renderBlock = () => {
    const isOpacity = animationProp === 'opacity'
    const animatePropsCommon: AnimateHeightProps = {
      children,
      height: open || isOpacity ? 'auto' : 0,
    }
    const animatePropsOpacity: AnimateHeightProps = {
      ...animatePropsCommon,
      id,
      className: classes['form__opacity-anim'],
      style: {
        opacity: open ? '1' : '0',
        zIndex: open ? 1 : -1,
      },
    }
    const animatePropsHeight: AnimateHeightProps = {
      ...animatePropsCommon,
      duration: duration || 0,
      onAnimationEnd: () => handleAnimationEnd(),
    }

    return (
      <AnimateHeight
        {...(isOpacity ? animatePropsOpacity : animatePropsHeight)}
      />
    )
  }

  return renderBlock()
}
